'use strict';

angular.module('amexReconciliationApp')
  .directive('accountingField',
    function () {
      return {
        restrict: 'AE',
        templateUrl: 'scripts/views/directives/accounting-field.html',
        scope: {},
        bindToController: {
          schema: '<',
          field: '=',
          accountingFieldDisabled: '<',
          refreshMaskValidationErrorsCount: '&',
          updateAllocationsValidity: '&',
          clearLowerComboValues: '&',
          allocationIndex: '<',
          allocation: '<',
          comboFieldFlag: '<'
        },
        controller: function ($element, $translate, $uibModal, $rootScope) {
          var self = this;
          
          self.displayLoadingMessage = function() {
            return self.displayLoadingMessageFlag && self.isFocused;
          };

          self.moreCodesDisabled = function() {
            return self.accountingFieldDisabled || self.schema.validationIndicator === 'N';
          };
          
          self.openAccountingCodeModal = function () {
            var modalScope = $rootScope.$new();
            modalScope.schema = self.schema;
            modalScope.field = self.field;
            modalScope.allocation = self.allocation;
            modalScope.allocationIndex = self.allocationIndex;
            modalScope.onFieldValueChanged = self.onFieldValueChanged;
            modalScope.clearLowerComboValues = self.clearLowerComboValues;

            $uibModal.open({
              template: '<accounting-code-modal schema="schema" ' +
                                                'field="field" ' +
                                                'allocation="allocation" ' +
                                                'allocation-index="allocationIndex" ' +
                                                'close-modal-callback="$close()" ' +
                                                'clear-lower-combo-values="clearLowerComboValues({index:index,position:position})" ' +
                                                'on-field-value-changed="onFieldValueChanged()"></accounting-code-modal>',
              scope: modalScope,
              animation: false
            });
          };

          
          
          self.onFieldValueChanged = function () {
            $element.find('input').controller('ngModel').$setDirty();
          };

          self.getMaskTooltip = function() {
            var tmp = _.uniq(self.schema.maskPattern.split(''));
            var maskChars = _.filter(tmp, function(item) {
              return MASK_DESCRIPTIONS[item];
            });
            var maskTooltip = '<div class="text-left">Mask Pattern: <br/>' +
              self.schema.maskPattern + '' +
              '<hr/> Keys: <br/>';
            maskChars.forEach(function(char){
              maskTooltip += char + ' : ';
              maskTooltip += '<span>' + $translate.instant(MASK_DESCRIPTIONS[char]) + '</span>';
              maskTooltip += '<br/>';
            });
            maskTooltip += '</div>';
            return maskTooltip;
          };

          self.isInSelectedComboFieldSet = function() {
            return self.schema.validationComboId === self.comboFieldFlag.validationComboId &&
                   self.allocationIndex === self.comboFieldFlag.allocationIndex &&
                   self.schema.validationComboId !== 0;
          };
        },
        controllerAs: '$ctrl'
      };
    });

var MASK_DESCRIPTIONS = {
  'A': 'mask.A',
  'a': 'mask.a',
  'B': 'mask.B',
  'b': 'mask.b',
  'C': 'mask.C',
  'c': 'mask.c',
  'd': 'mask.d',
  'e': 'mask.e',
  'l': 'mask.l',
  'M': 'mask.M',
  'm': 'mask.m',
  'N': 'mask.N',
  'n': 'mask.n',
  'U': 'mask.U'
};



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/accountingField.js
// module id = 509
// module chunks = 0